import { Component } from '@angular/core';
import { App, Platform, Events, NavController } from 'ionic-angular';
import { AppVersion } from '@ionic-native/app-version';
import { Market } from '@ionic-native/market';

import { User }   from '../../providers/user/user';
import { Utils }  from '../../providers/utils/utils';
import { IPTV }   from '../../providers/iptv/iptv';
import { Api }    from '../../providers/api/api';

import { Disconnect }  from '../../pages/disconnect/disconnect';
import { Licenses }    from '../../pages/licenses/licenses';
import { Userguide }   from '../../pages/userguide/userguide';
import { Logs }        from '../../pages/logs/logs';

import { ENV } from '@app/env';

/*
*
*  Account Page
*
*/
@Component({
  selector: 'account',
  templateUrl: 'account.html'
})
export class Account {

    public form: any = {};

    public version : string = '';
    public packageName : string = '';
    public showLog : number = 0;
    public ENV: any = {};
    
    constructor(  
        public platform: Platform,
        public appVersion: AppVersion,
        private navCtrl: NavController,  
        private market: Market,
        public utils: Utils,
        public user: User,
        public IPTV: IPTV,
        public api: Api,
        private app: App,
        public events: Events
    ) {
        this.ENV = ENV;
    }

    openUserGuide() {
        this.navCtrl.push(Userguide);
    }


    goToMarket() {
        if (this.utils.isBrowser()) return false;

        if (this.utils.isAndroid()) this.market.open('app.airmont.tv');

        this.market.open('id1490234347');
    }

    goToLicenses() {
        this.navCtrl.push(Licenses);
    }

    goToLogs() {
        this.navCtrl.push(Logs);
    }

    disconnect() {

        let that = this;
        this.utils.confirm({message: 'Are you sure to disconnect ?'}, function() {
            that.user.isDisconnecting = true;
            that.app.getRootNav().setRoot(Disconnect);
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/account/account.ts